<div class="SAS_Navbar">
  <!-- Header -->
  <app-outer-pages-header></app-outer-pages-header>

  <section class="about-jtc top-background no-printme">
    <div class="background-image">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb custom-breadcrumb">
            <li class="breadcrumb-item">
              <a [routerLink]="['/']">الرئيسية</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              المنصة العلاجية
            </li>
          </ol>
        </nav>
        <h1 class="sub-title">المنصة العلاجية</h1>
      </div>
    </div>
  </section>

  <div class="intro2">
    <!-- <div class="container"> -->
    <!-- <div class="row">
        <div class="col-md-4 col-sm-12">
          <h4 class="sub-title"> المنصة العلاجية</h4>
        </div> -->

    <!-- التشخيص - العلاج -->
    <!-- <div class="col-lg-6 col-sm-12 row text-white justify-content-around">

          <div class="service bg-site-color pt-3 px-4 pointer hvr-wobble-bottom" style="border-radius: 0 0 5px 5px; min-width: 140px;" [routerLink]="['/auth/basic-data/Platform']">
            <h3 class="text-center font-size-22 mb-0">التشخيص</h3>
            <div class="icon-container flex justfy-center" style="height: 100px;align-items: center;">
              <img src="assets/images/online.png" alt="SEU" width="50px" height="50px">
            </div>
          </div>

          <div class="service bg-site-color pt-3 px-4 pointer hvr-wobble-bottom" style="border-radius: 0 0 5px 5px; min-width: 140px;" [routerLink]="['/Sas/TreatmentPlatform']">
            <h3 class="text-center font-size-22 mb-0">العلاج</h3>
            <div class="icon-container flex justfy-center" style="height: 100px;align-items: center;">
              <img src="assets/images/medicinee.png" alt="SEU" width="50px" height="50px">
            </div>
          </div>

        </div> -->

    <!-- <div class="col-md-8 col-sm-12">
          <button class="btn mx-4 px-4 bg-site-color" [routerLink]="['/auth/basic-data/Platform']" style="margin-top: 25px;border: none;">التشخيص <i class="fas fa-sign-in-alt pr-2"></i> </button>
          <button class="btn px-4 bg-site-color" [routerLink]="['/Sas/TreatmentPlatform']" style="margin-top: 25px;border: none;">العلاج <i class="fas fa-sign-in-alt pr-2"></i></button>
        </div> -->
    <!-- </div>
    </div> -->

    <div class="container">
      <div class="medical-center medicalCenter">
        <!-- <h3 class="text-center heading-title mb-4 text-site-color">
          المنصة العلاجية للعلاج عن بعد
        </h3> -->
        <div class="section-title">
          <h2>المنصة العلاجية للعلاج عن بعد</h2>
        </div>

        <div class="row g-24">
          <!-- <div class="col-lg-4">
            <img
              src=".././../../assets/images/Doctor-Examining-Child.jpg"
              class="img-fluid img-thumbnail-edit"
            />
          </div> -->

          <div class="col-lg-8">
            <div class="medicalCenterContent">
              <p>
                إلى جانب المركز العلاجي قامت الشركة بإنشاء (منصة علاجية ) يتم
                الوصول إليها من خلال موقع الكتروني، وتطبيق على الهواتف الذكية،
                <a href="#" target="_blank" class="text-site-color"
                  >(اضغط هنا لتحميل التطبيق)</a
                >
                تهدف إلى تشخيص التلعثم وعلاجه حاليا، وبعد ذلك نعتزم التوسع
                تدريجيا لتشمل المنصة علاج اضطرابات أخرى.
              </p>
              <p>
                نسعى من خلال المنصة إلى تسهيل وصول المريض إلى خدماتنا من أي
                مكان، وفي أي وقت؛ ليتمكن من خلال هذه المنصة الدخول إلى كافة
                خدماتنا المهيئة للتشخيص والعلاج والمتابعة.
              </p>
              <p>
                والمنصة تمر مع المريض على مراحل التشخيص، والعلاج، والمتابعة
                لحالته، بطريقة ميسرة وسهلة.
              </p>
            </div>
            <div class="d-flex mt-4" style="gap: 8px">
              <a
                class="btn btn-primary"
                [routerLink]="['/auth/basic-data/Platform']"
                >التشخيص</a
              >
              <a
                class="btn btn-outline-light"
                [routerLink]="['/Sas/TreatmentPlatform']"
                >العلاج</a
              >
            </div>
          </div>

          <div class="col-lg-4">
            <img
              src=".././../../assets/images/banner2.jpg"
              class="img-fluid img-thumbnail-edit"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="Goals center-goals">
      <div class="container auto">
        <!-- <div class="icon-container flex justfy-center pb-4">
          <i class="fas fa-tv fa-5x icon-rounded bg-white text-site-color"></i>
        </div>
        <h3 class="text-center heading-title mb-4 text-white">
          أهدافنا في المنصة العلاجية
        </h3> -->

        <div class="section-title">
          <h2>أهدافنا في المنصة العلاجية</h2>
        </div>

        <div class="col-12">
          <ul>
            <li>
              <!-- <i class="fas fa-caret-left text-white fa-2x"></i> -->
              <img
                src="assets/images/icons/check-icon-green.svg"
                alt="check icon"
              />
              تشخيص المرضى وعلاجهم ومتابعتهم في أماكنهم دون الحاجة إلى مراجعة
              المراكز الطبية المختصة.
            </li>
            <!-- <li class="flex"><i class="fas fa-caret-left text-white fa-2x"></i>سهولة استشارة استشاريين وأخصائيين في مجال علاج اضطرابات التخاطب والسمع لتحديد حالتهم.</li> -->
            <li>
              <!-- <i class="fas fa-caret-left text-white fa-2x"></i> -->
              <img
                src="assets/images/icons/check-icon-green.svg"
                alt="check icon"
              />
              سهولة استفادة المرضى على مستوى العالم من الخدمة في أي مكان وفي أي
              وقت حول العالم.
            </li>
            <li>
              <!-- <i class="fas fa-caret-left text-white fa-2x"></i> -->
              <img
                src="assets/images/icons/check-icon-green.svg"
                alt="check icon"
              />
              تدريب الأخصائيين في مجال معالجة اضطرابات التخاطب والسمع في
              المستقبل القريب.
            </li>
            <li>
              <!-- <i class="fas fa-caret-left text-white fa-2x"></i> -->
              <img
                src="assets/images/icons/check-icon-green.svg"
                alt="check icon"
              />
              التوسع في هذه المنصة قريبا لتشخيص وعلاج اضطرابات أخرى.
            </li>
            <li>
              <!-- <i class="fas fa-caret-left text-white fa-2x"></i> -->
              <img
                src="assets/images/icons/check-icon-green.svg"
                alt="check icon"
              />
              ارتكاز المنصة على استشاريين واخصائيين متخصصين في علاج اضطرابات
              التخاطب.
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="Pros center-pros">
        <!-- <h3
          class="text-center heading-title mb-4 text-site-color borderAfter-lg"
        >
          الخدمات المقدمة في المنصة العلاجية
        </h3> -->

        <div class="section-title">
          <h2>الخدمات المقدمة في المنصة العلاجية</h2>
        </div>

        <div class="row">
          <!-- <div class="col-sm-12 col-lg-6">
            <img
              src=".././../../assets/images/ArabicKidTalking.jpg"
              class="img-fluid img-thumbnail-edit"
            />
          </div> -->

          <div class="col-12">
            <ul>
              <li>
                <!-- <i class="fas fa-caret-left text-site-color fa-2x"></i> -->
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                تشخيص المريض وتقديم تقرير كامل له مع مقابلة المختص عبر المنصة
                لتشخيص حالته.
              </li>
              <li>
                <!-- <i class="fas fa-caret-left text-site-color fa-2x"></i> -->
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                تقديم العلاج للمريض من خلال العديد من الجلسات العلاجية ويقوم
                المريض خلالها بالعديد من الأنشطة في مكانه بمتابعة من خلال
                المختص.
              </li>
              <li>
                <!-- <i class="fas fa-caret-left text-site-color fa-2x"></i> -->
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                تقديم تقرير نهائي بعد انتهاء فترة العلاج للمريض.
              </li>
              <li>
                <!-- <i class="fas fa-caret-left text-site-color fa-2x"></i> -->
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                خدمة مستشارك في التخاطب في المنصة تساعد المريض في تشخيص حالته من
                خلال الالتقاء بالمختص عبر المنصة لتشخيص حالته في أي من اضطرابات
                التخاطب والسمع إضافة إلى اضطراب التلعثم.
              </li>
              <li>
                <!-- <i class="fas fa-caret-left text-site-color fa-2x"></i> -->
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                سيقوم على المنصة مختصين واستشاريين اكفاء على مستوى العالم لتقديم
                الخدمات بأفضل الممارسات المهنية.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="OurServices center-services center-pros">
      <div class="container">
        <!-- <h3
          class="text-center heading-title mb-4 text-site-color borderAfter-lg"
        >
          مزايا المنصة العلاجية
        </h3>
        <h4 class="text-center mb-4 text-site-color">
          إليك بعض من مزايا المنصة العلاجية
        </h4> -->

        <div class="section-title">
          <h2>مزايا المنصة العلاجية</h2>
          <p>إليك بعض من مزايا المنصة العلاجية</p>
        </div>

        <div class="row">
          <div class="col-12">
            <ul>
              <li>
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                الوصول للخدمة في أي وقت وفي أي مكان بحيث يتجنب المريض عناء السفر
                والتنقل والانتظار والمتابعة وغيرها.
              </li>
              <li>
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                الحصول على خدمة علاجية من خلال المنصة متكاملة دون الحاجة للحضور
                ومقابلة المختص.
              </li>
              <li>
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                الحصول على خدمة الاستشارة العلاجية لكافة اضطرابات التخاطب
                والسمع.
              </li>
              <li>
                <img
                  src="assets/images/icons/check-icon-green.svg"
                  alt="check icon"
                />
                الحصول على تقرير معتمد للتشخيص لحالة التلعثم لدى المريض.
              </li>
            </ul>
          </div>
        </div>

        <!-- <div class="item-list font-size-lg flex justfy-center wrap">
          <div class="item my-4 hvr-wobble-bottom">
            الوصول للخدمة في أي وقت وفي أي مكان بحيث يتجنب المريض عناء السفر
            والتنقل والانتظار والمتابعة وغيرها.
          </div>
          <div class="item my-4 hvr-wobble-bottom">
            الحصول على خدمة علاجية من خلال المنصة متكاملة دون الحاجة للحضور
            ومقابلة المختص.
          </div>
          <div class="item my-4 hvr-wobble-bottom">
            الحصول على خدمة الاستشارة العلاجية لكافة اضطرابات التخاطب والسمع.
          </div>
          <div class="item my-4 hvr-wobble-bottom">
            الحصول على تقرير معتمد للتشخيص لحالة التلعثم لدى المريض.
          </div>
        </div> -->
      </div>
    </div>
  </div>
  <!-- Footer -->
  <app-outer-pages-footer></app-outer-pages-footer>
</div>
